export default "__VITE_ASSET__0c57bcc0__"